export default __webpack_public_path__ + "static/media/misc009.c1dbfba5.jpeg";